import * as React from 'react';
import { Textarea as PrivateTextarea } from '@chakra-ui/core';

type TextareaProps = any & {};

const Textarea: React.FC<TextareaProps> = (props: any): React.ReactElement => (
    <PrivateTextarea {...props} />
);

export default Textarea;
